const keepProperties = [
  'type',
  'id',
  'name',
  'src',
  'focalpoint',
  'href',
  'moviesCount',
  'moviesHref',
  'scenesCount',
  'scenesHref',
  'clipsCount',
  'clipsHref',
  'currentPrice',
  'regularPrice',
  'prices',
  'durationSeconds',
  'quality',
  'thumbnailClip',
  'availability',
]

function carddata(items) {
  return items.map((item) => {
    const reducer = (acc, property) => {
      if (typeof item.data[property] !== 'undefined') {
        acc[property] = item.data[property]
      }

      return acc;
    };

    const reducedData = keepProperties.reduce(reducer, {});

    if (item.data.studio) {
      reducedData.studio = {
        id: item.data.studio.id,
        name: item.data.studio.name,
        href: item.data.studio.href,
      }
    }

    if (item.data.amateur) {
      reducedData.amateur = {
        name: item.data.amateur.name,
        href: item.data.amateur.href,
      }
    }

    return {
      component: item.component,
      data: reducedData,
    }
  });
}

module.exports = carddata;



// WEBPACK FOOTER //
// ./src/libs/twig/carddata/index.js